<template>
  <main class="page-content mb-auto w-100 text-center" aria-label="Content">
    <div id="profile-person">
      <div class="section-wrap">
        <div class="section-content">
          <div class="user-avatar">
            <img :src="user.data.photoURL" v-if="user.data.photoURL != ''" />
            <i v-if="user.data.photoURL == ''" class="stg st-single-neutral-circle-2" />
          </div>
          <div class="content">
            <div class="header mt-3 mb-3">
              <h1>{{user.data.displayName}}</h1>
            </div>
            <div class="content-center-group">
              <div>Du hast dich dafür entschieden, deine Lieblingsläden mit folgendem Solidaritätsbeitrag zu unterstützen.</div>
              <h1 class="text-primary mt-3">{{total.money | toCurrency}}</h1>
            </div>
          </div>
        </div>
      </div>
      <div class="section-wrap-full-width bg-error mt-3">
        <div class="analytics-wrapper flex-row justify-content-center align-items-center">
          <i class="stg st-love-heart-hands-hold-3 text-white py-0"></i>
          <h3 class="text-white ml-2 my-0">Du bist der Oberhammer!</h3>
        </div>
      </div>
      <div class="section-wrap">
        <div class="section-content">
          <div class="content-center-group">
            <div
              class="text-center mb-5 col-12 col-md-8"
            >Es kann sein, dass dein Lieblingsladen das nicht möchte. Bitte akzeptiere eine allfällige Ablehnung deines Soli-Beitrags.</div>

            <ticket-component v-for="donation in donations" :key="donation.id" :id="donation.id" />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "firebase/app";

import Ticket from "@/components/Ticket.vue";

let db = firebase.firestore();
let usersRef = db.collection("users");

export default {
  name: "UserDetail",
  components: {
    ticketComponent: Ticket
  },
  data: function() {
    return {
      donations: [],
      total: {
        money: null,
        donations: null
      }
    };
  },
  computed: {
    ...mapGetters({
      user: "user"
    })
  },
  mounted: function() {
    let $this = this;

    usersRef
      .doc(this.user.data.uid)
      .collection("donations")
      .get()
      .then(function(querySnapshot) {
        $this.total.donations += querySnapshot.size;
        querySnapshot.forEach(function(doc) {
          doc
            .data()
            .donationRef.get()
            .then(function(querySnapshot) {
              let donation = querySnapshot.data();
              if (donation.value) {
                $this.donations.push({
                  id: querySnapshot.id,
                  ...donation
                });
                $this.total.money += donation.value;
              }
            })
            .catch(function(error) {
              console.log("Error getting documents: ", error);
            });
        });
      })
      .catch(function(error) {
        console.log("Error getting documents: ", error);
      });
  }
};
</script>

<style>
</style>
